import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { Batch } from '@/types/batch';

/**
 * Retrieve information for a given batch, including the welcome message, list of materials, and debrief message.
 *
 * @param batchId - The ID of the batch to retrieve.
 * @returns A Promise resolving to the Axios response containing the batch.
 */
export async function batchGetQuery(
  batchId: string
): Promise<AxiosResponse<Batch>> {
  const requestOptions = {
    method: 'GET',
    url: `/batches/${batchId}/`,
    params: {
      expand: 'carelessResponseChecks,debrief,materials,welcome',
    },
  };

  return api(requestOptions);
}